import { render, staticRenderFns } from "./ContributeAricleForm.vue?vue&type=template&id=61a0770d&scoped=true"
import script from "./ContributeAricleForm.vue?vue&type=script&lang=js"
export * from "./ContributeAricleForm.vue?vue&type=script&lang=js"
import style0 from "./ContributeAricleForm.vue?vue&type=style&index=0&id=61a0770d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a0770d",
  null
  
)

export default component.exports